function checkURLAndModifyElement() {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (!urlParams.has('customer_posted') && urlParams.has('form_type') || urlParams.get('customer_posted') !== 'true' && urlParams.get('form_type') == 'customer') {
        const sampleElement = document.getElementById('Newsletter-already-in-use');
        
        if (sampleElement) {
            sampleElement.textContent = 'Email address is already registered';

            sampleElement.classList.add('show');
        }
    }
}

function listenForURLChange() {
    let oldHref = document.location.href;

    window.addEventListener('popstate', function () {
        const newHref = document.location.href;

        if (oldHref !== newHref) {
            oldHref = newHref;
            checkURLAndModifyElement();
        }
    });

    const originalPushState = history.pushState;
    history.pushState = function () {
        originalPushState.apply(this, arguments);
        checkURLAndModifyElement();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function () {
        originalReplaceState.apply(this, arguments);
        checkURLAndModifyElement();
    };
}

listenForURLChange();

checkURLAndModifyElement();
